import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import moment from 'moment';
import { likeComment, unlikeComment, deleteComment } from '../../actions/post';

const CommentItem = ({
  postId,
  comment: { _id, text, name, avatar, user, likes, date },
  auth,
  likeComment,
  unlikeComment,
  deleteComment
}) => (
  <div className="comment">
    <div className="card-body p-1 rounded-lg">
      {!auth.loading && user === auth.user._id && (
        <a
          href="#!"
          onClick={() => deleteComment(postId, _id)}
          className="text-secondary float-right delete mr-2"
        >
          <i className="fas fa-trash-alt"></i>
        </a>
      )}
      <div className="d-flex">
        <img
          src={avatar}
          className="rounded-circle comment-profile-pic"
          alt=""
        />
        <div className="comment-head">
          <Link className="comment-user" to={`/profile/${user}`}>
            <h6>{name}</h6>
          </Link>
          <span className="text-muted time">
            {' '}
            &#8226; <span>{moment(date).fromNow()}</span>
          </span>
        </div>
      </div>

      <p className="mx-2 my-1 comment-text">{text}</p>

      <div className="info">
        {auth.user._id &&
        likes.filter((like) => like.user === auth.user._id).length > 0 ? (
          <a
            href="#!"
            onClick={() => unlikeComment(postId, _id)}
            className="rb text-secondary"
          >
            Unlike
          </a>
        ) : (
          <a
            href="#!"
            onClick={() => likeComment(postId, _id)}
            className="rb text-secondary"
          >
            Like
          </a>
        )}
        {likes.length > 0 && (
          <span className="bold likes">
            {' '}
            | <i className="fas fa-thumbs-up"></i> {likes.length}
          </span>
        )}
      </div>
    </div>
  </div>
);

CommentItem.propTypes = {
  postId: PropTypes.string.isRequired,
  comment: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  likeComment: PropTypes.func.isRequired,
  unlikeComment: PropTypes.func.isRequired,
  deleteComment: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, {
  likeComment,
  unlikeComment,
  deleteComment
})(CommentItem);
